import "./styles/MessageBox.scss";
import { System_DeviceOrientationMap } from "../assets/keyMap";
import { AppContext } from "../Context";
import { useState, useEffect, useContext } from 'react';

interface Props {
    message: string,
    SetMessage: any,
    boxButtons: string[],
    BoxActions: any[],
}

const MessageBox: React.FC<Props> = ({ message, SetMessage, boxButtons, BoxActions }) => {
    //context
    const appContext = useContext(AppContext);
    //state
    const [showHideMessageBox, SetShowHideMessageBox] = useState("hide");

    useEffect(() => {
        if (message.length > 0)
            SetShowHideMessageBox('show');
        else
            SetShowHideMessageBox('hide');
    }, [message]);

    const GetBtnClassName = (i: number) => {
        if (boxButtons.length == 1)
            return "button-fill";
        else if (boxButtons.length > 1)
            if (i == 0)
                return "button-left";
            else if (i == (boxButtons.length - 1))
                return "button-right";
    }

    return (
        <div className={"MessageBox " + (showHideMessageBox) + ' ' + (appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : 'portrait')}>
            <div className='MessageBox-ui-block' />
            <div className='MessageBox-body'>
                {
                    message.includes('<span') ?
                    <span className='MessageBox-title' dangerouslySetInnerHTML={{__html: message}}></span>
                    :
                    <span className='MessageBox-title'>{message}</span>
                }
                {/* <div className='MessageBox-subtitle'>
                    <span className='MessageBox-subtitle-heavy'>Contact 1: <span>603 – 7727 6202</span></span>
                    <span className='MessageBox-subtitle-heavy'>Contact 2: <span>603 – 7727 6232</span></span>
                    <span className='MessageBox-subtitle-heavy'>Email: <span>secretariat@ppkm.org.my</span></span>
                </div> */}
                <div className='MessageBox-btn-panel'>
                    {boxButtons.map((button: string, i: number) => {
                        return (<button key={button + i} className={GetBtnClassName(i)} onClick={() => {
                            //execute desired actions
                            BoxActions[i]();

                            //reinitialisation -- if popupButtons and popupActions not set will use these defaults
                            appContext.SetPopupButtons(['Ok']);
                            appContext.SetPopupActions([() => {/*empty function*/}]);
                            SetMessage('');
                        }}>{button}</button>);
                    })}
                </div>
            </div>
        </div>
    );
};

export default MessageBox;